import React from 'react'
import { Sector, SectorProps } from 'recharts'

interface ShopPieChartActiveShapeProps {
  selector: SectorProps
  borderColor: string
}

/*
 * Custom rendering component for highlighting the active segment in a pie.
 */
const ShopPieChartActiveShape: React.FC<ShopPieChartActiveShapeProps> = ({ selector, borderColor }) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = selector
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        stroke={borderColor}
        strokeWidth={2}
      />
    </g>
  )
}

export default ShopPieChartActiveShape
